module.exports = __webpack_public_path__ + "static/scientist1-d1e385891929a3c8d7558a70111dc862.png";